import ClassOutlinedIcon from "@mui/icons-material/ClassOutlined";
import ListGoogleCourses from "./List";
import CreateGoogleCourses from "./Create";
import EditGoogleCourses from "./Edit";
import ShowGoogleCourses from "./Show/Show";
import { COURSES, GoogleServicePath } from "utils/constants";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <ClassOutlinedIcon />,
  name: GoogleServicePath + COURSES,
  title: "Google Зали",
  recordRepresentation: "name",
  list: <ListGoogleCourses />,
  create: <CreateGoogleCourses />,
  createPermission: permissions.canCreateGoogleClassroomCourse,
  edit: <EditGoogleCourses />,
  editPermission: permissions.canUpdateGoogleClassroomCourse,
  show: <ShowGoogleCourses />,
  showPermission: permissions.canPreviewGoogleClassroomCourses,
  permission: permissions.canPreviewGoogleClassroomCourses,
};
